import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import divider from '../images/about/16001576619262.jpg';
import '../styles/about.css';

const About = () => {
  // Function to render the repeated content
  const renderContent = () => (
    <div className="content">
      <h3>
        Uzm. Dr. BİRSEN ERGUS <br /> Dermatoloji Uzmanı
      </h3>
      <p>Merhaba,</p>
      <p>
        Kütahya'nın Gediz ilçesinde doğdum. İlk, orta ve lise öğrenimimi Gediz'de bitirdim. İstanbul
        Üniversitesi Cerrahpaşa Tıp Fakültesi'nden 1988 yılında mezun oldum.
      </p>
      <p>
        1988-1990 yılları arasında Kahramanmaraş Göksun İlçesinde zorunlu hizmet yaptım. 1990-1993
        yılları arasında Bursa'da pratisyen hekim olarak çalıştım.
      </p>
      <p>
        1993-1996 yılları arasında Uludağ Üniversitesi Tıp Fakültesi'nde Dermatoloji Uzmanlık
        eğitimimi aldım.
      </p>
      <p>
        1996-2011 yılları arasında Bursa Onkoloji Hastanesinde, 2011-2014 yılları arasında Özel
        Medicabil Hastanesinde Dermatoloji Uzmanı olarak çalıştım.
      </p>
      <p>2014 Kasım ayında kendi kliniğimde çalışmaya başladım.</p>
      <p>
        Kliniğimde; deri ve zührevi hastalıklarının tanı ve tedavileri, alerjik deri hastalıklarının
        tanı ve tedavileri, alerji testleri ve bunların yanı sıra estetik ve lazer uygulamaları
        yapmaktayım.
      </p>
    </div>
  );

  return (
    <div className="about-page">
      <Container>
        <Row className="mt-4">
          {/* Large screens */}
          <Col lg={6} className="d-none d-lg-block">
            <Image src={divider} fluid className="mb-4" style={{ width: '100%' }} />
          </Col>
          <Col lg={6} className="d-none d-lg-block">
            {renderContent()}
          </Col>

          {/* Small screens */}
          <Col xs={12} className="d-block d-lg-none">
            <Image src={divider} fluid className="mb-4" style={{ width: '100%' }} />
          </Col>
          <Col xs={12} className="d-block d-lg-none">
            {renderContent()}
          </Col>
         
        </Row>
      </Container>
    </div>
  );
};

export default About;
